import React, { Component, PropTypes } from 'react';
import { mixin, RefluxMixin } from 'Util';
import MediaLibraryStore from 'stores/MediaLibrary';
import MediaLibraryActions from 'actions/MediaLibrary';
import Loader from 'components/Material/Loader';
import FileSelector from 'components/Widgets/FileSelector';

export default class FileSelectorContainer extends mixin(
  RefluxMixin,
  Component
) {
  static displayName = 'FileSelectorContainer';

  listenToStores() {
    this.listenToStore(MediaLibraryStore);
  }

  componentDidMount() {
    MediaLibraryActions.listDirectory(0);
  }

  changeDir(dir) {
    MediaLibraryActions.listDirectory(dir);
  }

  render() {
    if (this.state.loading) {
      return <Loader />;
    }
    return (
      <FileSelector
        breadcrumbs={this.state.breadcrumbs}
        onChangeDirectory={this.changeDir.bind(this)}
        items={this.state.list}
        {...this.props}
        labelProperty="name"
      />
    );
  }
}



// WEBPACK FOOTER //
// ./src/js/components/Widgets/FileSelectorContainer.js